import React from 'react'
import { GenericTable } from '../_EOS/Table'
import { Button, Grid } from '@mui/material'
import { headersConfig } from './config'
import { ReturnWorkOrderResponse } from './types'
import { useStyles } from './styles'

interface MultipleReturnsProps {
  data: ReturnWorkOrderResponse[]
  setSelectedWorkOrder: (workOrderId: number) => void
  handleStep: (step: number) => void
}

export const MultipleReturns: React.FC<MultipleReturnsProps> = ({
  data,
  setSelectedWorkOrder,
  handleStep
}) => {
  const classes = useStyles()

  const [selectedElement, setSelectedElement] = React.useState<number[]>([])

  const handleCheckChange = (id: number, _checked: boolean) => {
    setSelectedElement([id])
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <GenericTable<ReturnWorkOrderResponse>
          headersConfig={headersConfig}
          data={data}
          showCheckboxes
          onCheckChange={handleCheckChange}
          checkedElements={selectedElement}
          IDKey='workOrderId'
          dense={true}
        />
      </Grid>
      <Grid item xs={6}>
        <div className={classes.centerButton}>
          <Button
            onClick={() => handleStep(1)}
            variant='contained'
            color='primary'
          >
            Volver
          </Button>
        </div>
      </Grid>
      <Grid item xs={6}>
        <div className={classes.centerButton}>
          <Button
            disabled={selectedElement.length === 0}
            onClick={() => setSelectedWorkOrder(selectedElement[0])}
            color='primary'
            variant='contained'
          >
            Seleccionar
          </Button>
        </div>
      </Grid>
    </Grid>
  )
}
